<script>
  export default {
    name: 'ConfirmDialog',

    data: () => ({
      title: '',
      subTitle: '',
      text: '',
      yesText: '',
      noText: '',
      showDialog: false,
      yesVisible: false,
      noVisible: false,
      callback: async () => {},
    }),

    computed: {
      confirmDialog() {
        return this.$store.getters['getConfirmDialog'];
      },
    },

    watch: {
      confirmDialog() {
        this.showDialog = !!this.confirmDialog;

        if (!this.confirmDialog) {
          this.callback = () => {};
          return;
        }

        const {
          text,
          title,
          subTitle,
          callback,
          yesText = 'Yes',
          noText = 'No',
          yesVisible = true,
          noVisible = true,
        } = this.confirmDialog;

        this.text = text;
        this.title = title;
        this.subTitle = subTitle;
        this.callback = callback;
        this.yesText = yesText;
        this.noText = noText;
        this.yesVisible = yesVisible;
        this.noVisible = noVisible;
      },
    },

    methods: {
      async accept() {
        await this.callback();
        this.closeDialog();
      },
      closeDialog() {
        this.$store.dispatch('hideConfirmDialog', null);
      },
    },
  };
</script>

<template>
  <v-dialog
    v-if="showDialog"
    v-model="showDialog"
    content-class="confirm-dialog alert-shadow rounded-borders-5"
    max-width="600px"
    @click:outside="closeDialog"
    @keydown.esc="closeDialog"
  >
    <v-card class="d-flex flex-column justify-center align-center position-relative py-6">
      <v-icon color="white" size="36" @click="closeDialog">mdi-close</v-icon>

      <v-card-title class="justify-center px-5">
        <span class="white--text font-weight-bold">
          {{ title }}
        </span>
      </v-card-title>
      <v-card-text class="white--text text-center font-weight-semi" v-html="text" />
      <v-card-actions class="gap-24 w-full px-6 px-sm-7 justify-center">
        <action-button class="w-full action-button">
          <template #action="{ loading, clickHandler }">
            <v-btn
              v-if="yesVisible"
              :loading="loading"
              class="confirm-btn golden-button w-full"
              @click="clickHandler(accept)"
            >
              {{ yesText }}
            </v-btn>
          </template>
        </action-button>
        <div v-if="noVisible" class="w-full action-button">
          <v-btn class="confirm-btn golden-button red-bright w-full" @click="closeDialog">
            {{ noText }}
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
  .gap-24 {
    gap: 24px;
  }

  .confirm-dialog {
    .v-card {
      .v-icon {
        position: absolute;
        right: 15px;
        top: 10px;
      }
    }

    .v-card__title {
      width: 100%;

      span {
        font-size: clamp(20px, 6vw, 28px);
        text-align: center;
        word-break: break-word;
      }
    }

    .v-card__text {
      font-size: clamp(18px, 2vw, 20px);
      text-align: center;
      word-break: break-word;
    }
  }

  .action-button {
    flex-basis: 50%;
  }

  .confirm-btn {
    min-width: 100px !important;
  }
</style>
